import React, { useEffect } from "react";
import SectionHeading from "../components/ui/SectionHeading";
import ContactForm from "../components/ui/ContactForm";
import ContactInfo from "../components/contact/ContactInfo";
import OfficeLocations from "../components/contact/OfficeLocations";

const ContactPage = () => {
  useEffect(() => {
    document.title = "Contact Us | Professional Service Associates";
  }, []);

  return (
    <>
      <div className="bg-psa-green-600 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center font-display">
            Contact Us
          </h1>
          <p className="text-psa-green-100 text-lg mt-4 max-w-3xl mx-auto text-center">
            Reach out to our team for professional assistance with your Tax,
            VAT, RJSC, BIDA & business needs.
          </p>
        </div>
      </div>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <SectionHeading
            title="Get in Touch"
            subtitle="Have questions or need assistance? Fill out the form below and our team will get back to you promptly."
            center
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mt-12">
            <div className="lg:col-span-2">
              <ContactForm />
            </div>
            <div className="lg:col-span-1">
              <ContactInfo />
            </div>
          </div>
        </div>
      </section>

      <OfficeLocations />
    </>
  );
};

export default ContactPage;
